// @flow
export default class Neighborhood {
  id: string;
  name: string;
  location: Object;
  city: string;
  isPrincipal: boolean;
  enabled: boolean;

  constructor(data: any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.location = data.location;
    this.city = data.city;
    this.isPrincipal = data.is_principal;
    this.enabled = data.enabled;
  }
}
